var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Notifications.length)?_c('div',{style:({
    position: "fixed",
    right: "10px",
    top: "50px",
    height: "auto",
    zIndex: "10000",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  })},[_c('div',{style:({
      heigh: "80px",
      overflow: 'auto',
    })},_vm._l((_vm.Notifications),function(notification){return _c('div',{key:notification.key},[_c('v-alert',{attrs:{"type":notification.type,"min-width":"200px","border":"left"}},[_vm._v(" "+_vm._s(notification.message)+" ")])],1)}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }